import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PeriodoService {
  private _periodoSelecionado = signal<{ periodBegin: string; periodEnd: string } | null>(null);

  periodoSelecionado() {
    return this._periodoSelecionado;
  }

  periodoSelecionado$ = toObservable(this._periodoSelecionado).pipe(
    debounceTime(400), 
    distinctUntilChanged((a, b) =>
      a?.periodBegin === b?.periodBegin && a?.periodEnd === b?.periodEnd
    )
  );

  setPeriodoSelecionado(begin: Date | string, end: Date | string): void {
    this._periodoSelecionado.set({
      periodBegin: this.formatDate(begin),
      periodEnd: this.formatDate(end),
    });
  }

  private formatDate(d: Date | string): string {
    let date: Date | null = null;

    if (d instanceof Date && !isNaN(d.getTime())) {
      date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    } else if (typeof d === 'string' && d.includes('-')) {
      const [y, m, day] = d.split('-').map(Number);
      if (!isNaN(y) && !isNaN(m) && !isNaN(day)) {
        date = new Date(y, m - 1, day);
      }
    }

    return date
      ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
      : '';
  }
}
